class TrackMyOrderInformationComponentController {
    constructor(settings) {
        this.settings = settings;
    }

    $onInit() {
        if (this.tmoInfo.DeliveryMethod === 'NotRetrieved') return;

        this.orderInfo = this.getOrderInfo();
        this.dateInfo = this.getDateInfo();
        this.addressInfo = this.getAddressInfo();
        this.storeInfo = this.getStoreInfo();
    }

    getOrderInfo() {
        return {
            method: this.tmoInfo.DeliveryMethod,
            headerTexts: this.getHeaderTexts(),
            canLeaveUnattended: this.tmoInfo.CanLeaveOrderUnattended,
            instructions: this.tmoInfo.DeliveryInstructions,
        };
    }

    getHeaderTexts() {
        return {
            delivery: this.settings.trackMyOrder.deliveryWindowLabel,
            express: this.settings.trackMyOrder.expressDeliveryWindowLabel,
            pickup: this.settings.trackMyOrder.pickupWindowLabel,
        };
    }

    getAddressInfo() {
        if (this.tmoInfo.DeliveryMethod === 'Pickup' && !this.tmoInfo.Store) return null;
        if (this.tmoInfo.DeliveryMethod === 'Pickup') {
            return {
                street1: this.tmoInfo.DeliveryInfo.AddressLine2,
                suburb: this.tmoInfo.Store.State,
                postcode: this.tmoInfo.Store.Postcode,
            };
        }
        return {
            street1: this.tmoInfo.DeliveryInfo.AddressLine1,
            street2: this.tmoInfo.DeliveryInfo.AddressLine2,
        };
    }

    getDateInfo() {
        const deliveryTime = this.tmoInfo.DeliveryWindowInfo.TimeSpan.split(' - ');
        const dateInfo = {
            date: this.tmoInfo.DeliveryWindowInfo.Date,
            startTime: deliveryTime[0],
            endTime: deliveryTime[1],
        };

        if (this.tmoInfo.EtaInfo && !this.tmoInfo.EtaInfo.IsUnavailable) {
            dateInfo.eta = {
                startTime: this.tmoInfo.EtaInfo.HourStart,
                endTime: this.tmoInfo.EtaInfo.HourEnd,
            };
        }

        return dateInfo;
    }

    getStoreInfo() {
        if (this.tmoInfo.DeliveryMethod !== 'Pickup') return null;

        return {
            name: this.tmoInfo.DeliveryInfo.AddressLine1,
            tradingHours: this.tmoInfo.TradingHours,
            details: this.tmoInfo.Store,
        };
    }
}

TrackMyOrderInformationComponentController.$inject = ['Settings'];

const trackMyOrderInformationComponentDefinition = {
    bindings: {
        tmoInfo: '<',
        store: '<',
        isGuest: '<',
    },
    controller: TrackMyOrderInformationComponentController,
    template: `
        <wow-order-information
            order-info="::$ctrl.orderInfo"
            address-info="::$ctrl.addressInfo"
            date-info="::$ctrl.dateInfo"
            store-info="::$ctrl.storeInfo"
            is-guest="::$ctrl.isGuest">
        </wow-order-information>
        <wow-order-information-tips
            order-method="::$ctrl.orderInfo.method">
        </wow-order-information-tips>
    `,
};

module.exports = {
    TrackMyOrderInformationComponentController,
    trackMyOrderInformationComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/trackmyorder/track-my-order-information.component.js